import React, { useEffect, useRef, useState } from "react"
import SwiperCore, { Navigation } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import ImageFadeIn from 'react-image-fade-in';
import "swiper/css"

SwiperCore.use([Navigation])

export const SwiperGallery = ({ slides }) => {
  const [swiperIndex, setSwiperIndex] = useState<number>(0)
  const [swiperCaption, setSwiperCaption] = useState<string>("")
  const swiperRef = useRef<Swiper>(null)

  useEffect(() => {
    setSwiperCaption(slides[swiperIndex]?.title || "")
  }, [swiperIndex])

  return (
    <>
      <Swiper
        ref={swiperRef}
        spaceBetween={20}
				breakpoints={{
					768: { spaceBetween: 30 },
				}}
        speed={500}
        slidesPerView="auto"
        onReachEnd={(swiper) => {
          setTimeout(() => {
            swiper.update()
            swiper.slideTo(0)
          }, 100)
        }}
        onActiveIndexChange={(swiper) => setSwiperIndex(swiper.activeIndex)}
      >
        {slides.map((slide: any, index: number) => (
          <SwiperSlide key={index}>
						<ImageFadeIn src={slide.url} loading="eager" className="slide-image" alt={slide.alt || slide.title || `Slide image ${slide.index + 1}`} />
          </SwiperSlide>
        ))}
      </Swiper>
			<div className="col">
				<div className="container row col-sm-7 col-xs-6 offset-sm-2">
					<div className="button-wrapper">
						<button
							type="button"
							className="heading-4-regular"
							// @ts-ignore
							onClick={() => swiperRef.current.swiper.slidePrev()}
						>
							←<span className="sr-only">Next</span>
						</button>
						&nbsp;&nbsp;
						<button
							type="button"
							className="heading-4-regular"
							// @ts-ignore
							onClick={() => swiperRef.current.swiper.slideNext()}
						>
							→<span className="sr-only">Next</span>
						</button>
					</div>
					<small className="caption">
						{swiperCaption}
					</small>
				</div>
			</div>
    </>
  )
}
